import React from 'react'

export const SingleArrowIcon = () => {
  return (
    <svg viewBox="0 0 62 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42.8679 30.9998L60.4566 16.4999L42.8679 2" stroke="currentColor" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 16.5H58.1285" stroke="currentColor" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}